import React, {
    useContext, useMemo
} from 'react';
import { TranslatorContext } from '@jutro/locale';
import { Link } from '@jutro/components';
import { SG_AA_PREMIUM_PAGE_ACTION } from 'sg-adobe-analytics/AdobeAnalyticsConstants';
import messages from './SgSphDeclarationsDocumentsUnoccupancy.messages';

function SgSphDeclarationsDocumentsUnoccupancy(props) {
    const {
        importantInfoLink
    } = props;

    const translator = useContext(TranslatorContext);

    const adobeBaseValue = `${SG_AA_PREMIUM_PAGE_ACTION.LEVEL_1.DECLARATIONS}|${SG_AA_PREMIUM_PAGE_ACTION.LEVEL_2.TEXT}|`;

    const goToDocuments = (event) => {
        if (event) {
            event.preventDefault();
        }
        const documentsUrl = window.location.href.split('/')[0];
        const newUrl = '#/Documents';
        window.open(documentsUrl + newUrl);
    };

    const importantInfo = useMemo(() => {
        return (
            <Link
                id="importantInfoLink"
                href={importantInfoLink}
                target="_blank"
                adobeValue={`${adobeBaseValue}${SG_AA_PREMIUM_PAGE_ACTION.LEVEL_3.IMPORTANT_STATEMENTS}`}
            >
                {translator(messages.ImportantInfoLink)}
            </Link>
        );
    }, []);

    const documentsLink = useMemo(() => {
        return (
            <Link
                id="documentsLink"
                href="/"
                onClick={goToDocuments}
                adobeValue={`${adobeBaseValue}${SG_AA_PREMIUM_PAGE_ACTION.LEVEL_3.IPID}`}
            >
                {translator(messages.DocumentsLink)}
            </Link>
        );
    }, [adobeBaseValue, translator]);

    return (
        <>
            {translator(messages.AcceptInfo)}
            <ul>
                <li>
                    {importantInfo}
                </li>
                <li>
                    {translator(messages.RenewalPageIpidDocumentsLink)}
                    {documentsLink}
                </li>
                <li>
                    {translator(messages.RenewalPage003Endorsement)}
                </li>
            </ul>
        </>
    );
}

export default SgSphDeclarationsDocumentsUnoccupancy;
